import { axiosInstance } from '@configs/axios/axiosInstance';

import type { GetInstructorsPendingLetterResult } from './getInstructorsPendingLetter.types';

/**
 * Fetch instructors with a pending approval letter.
 * Endpoint: GET /instructors/pending-letter
 *
 * `customerId` is sent as a request header.
 * Returns the total instructorCount and the list of pending approval letters.
 */
export async function getInstructorsPendingLetter(
  customerId: string
): Promise<GetInstructorsPendingLetterResult> {
  const response = await axiosInstance.get<GetInstructorsPendingLetterResult>(
    '/instructors/pending-letter',
    { headers: { 'X-Customer-Id': customerId } }
  );

  return response.data;
}
